import React, { useState } from "react";
import Skeleton from "react-loading-skeleton";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFViewer = ({ pdfFile, pdfWidth, pdfScale }) => {
  const [totalPages, setTotalPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setTotalPage(numPages);
  };

  const calculatedWidth = Math.round(738 * pdfScale);

  return (
    <div className="relative">
      <div className="pdf-container">
        <Document
          file={pdfFile}
          logLevel="0"
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<Skeleton height={1044} width={calculatedWidth} />}
        >
          <Page
            pageNumber={currentPage}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            logLevel="0"
            loading={<Skeleton height={1044} width={calculatedWidth} />}
            width={calculatedWidth}
          />
        </Document>
      </div>
    </div>
  );
};

export default PDFViewer;
